const NAMESPACE = 'jbp-plan-review'

export interface IPlanReviewTranslation {
  key: string
  fallback: string
}

const text = (suffix: string, fallback: string): IPlanReviewTranslation => ({
  key: `${NAMESPACE}-${suffix}`,
  fallback,
})

export const PLAN_REVIEW_TRANSLATIONS = {
  planningMeasure: {
    title: text('planning-measure-title', 'Planning measure'),
    header: text('planning-measure-header', 'Plan review - Planning measure'),
    plannedUsing: text(
      'planning-measure-planned-using',
      'Your plan was built using {actualsType}.'
    ),
    requirement: text(
      'planning-measure-requirement',
      'All FY{fYear} plans must be built and submitted using {actualsType}. This is a {mandatoryRequirement} across all markets.'
    ),
    mandatoryRequirement: text('planning-measure-mandatory-requirement', 'mandatory requirement'),
    justificationPrompt: text(
      'planning-measure-justification-prompt',
      'Please explain why {actualsType} could not be used for this plan.'
    ),
    issue: text(
      'planning-measure-issue',
      '{offering} / {category}: planned using {actualsType} instead of {defaultActualsType}.'
    ),
    noSavedMeasure: text(
      'planning-measure-no-saved-measure',
      'The planning measure could not be determined from the saved plan.'
    ),
    openFinancialSection: text('planning-measure-open-financial-section', 'Open Financial section'),
    loadError: text(
      'planning-measure-load-error',
      'The saved planning measure could not be loaded. Please close and reopen the review to try again.'
    ),
  },
  justification: {
    add: text('justification-add', 'Add justification'),
    edit: text('justification-edit', 'Edit justification'),
    provided: text('justification-provided', 'Justification provided'),
    missing: text('justification-missing', 'Justification is missing'),
    details: text('justification-details', 'Justification: {justification}'),
  },
  summary: {
    menu: text('summary-menu', 'Summary'),
    header: text('summary-header', 'Plan review - Summary'),
    congratulations: text(
      'summary-congratulations',
      'Congratulations! You have completed your plan.'
    ),
    weakPointsIntro: text(
      'summary-weak-points-intro',
      'We identified a few areas that need your attention. Please review them and either update the plan or provide a business justification before acknowledgment.'
    ),
    noWeakPoints: text(
      'summary-no-weak-points',
      'Your plan has no quality areas that require attention.'
    ),
    reviewOrJustify: text(
      'summary-review-or-justify',
      'Review each area in detail, or provide one overall business justification below.'
    ),
    reviewFirst: text('summary-review-first', 'Review weak points'),
    reviewDetails: text('summary-review-details', 'Review details'),
    itemsRequireAttention: text(
      'summary-items-require-attention',
      '{issueCount} of {totalCount} items require attention.'
    ),
    missingFinancialTargets: text(
      'summary-missing-financial-targets',
      '{issueCount} initiatives are missing financial targets.'
    ),
    descriptionsRequireAttention: text(
      'summary-descriptions-require-attention',
      '{issueCount} of {totalCount} initiative descriptions require attention.'
    ),
    prioritiesRequireAttention: text(
      'summary-priorities-require-attention',
      '{issueCount} of {totalCount} strategic growth areas are not covered.'
    ),
    financialTargetMissing: text(
      'summary-financial-target-missing',
      'Financial target is missing.'
    ),
    noLinkedInitiatives: text(
      'summary-no-linked-initiatives',
      'No initiatives are linked to this strategic growth area.'
    ),
    overallJustification: text('summary-overall-justification', 'Overall business justification'),
    saveAndAcknowledge: text('summary-save-and-acknowledge', 'Save and acknowledge'),
    pbmJustifications: text('summary-pbm-justifications', 'PBM justifications'),
    noPbmJustification: text(
      'summary-no-pbm-justification',
      'No PBM justification has been provided.'
    ),
  },
} as const
